import React, { useState, useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import translate from '../../../../helpers/translate';
import Margin from '../../../../components/shared/margin';
import Head from '../../../../components/shared/head';
import {commonStyles as stylesCommon} from '../../../../styles/common';
import {useSelector} from 'react-redux';
import Item from './intenList';
import LayoutContent from '../../../../components/layouts/content2';
import { styles } from './styles';
import {useNavigate, useLocation} from 'react-router-dom';


function Index() {
    const data = useLocation().state;
    const urlSegments = window.location.pathname.split('/');
    const categorie_id = urlSegments[urlSegments.length - 1];
   
    const navigate = useNavigate();
    const {allmenu} = useSelector((state) => state.initLoad);
    
    const commonStyles  = stylesCommon(); 
    
    const {t, i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menu, setMenu] = useState([]);
    const [titleCategorie, setIitleCategorie] = useState('');


    useEffect(()=>{
        if (allmenu) {
            const categorieItem = allmenu.data.find(
                (item) => 
                    item.id == categorie_id
                );
        
            if (categorieItem) {
                console.log({categorieItem})
                setMenu(categorieItem.menus);
                setIitleCategorie(langEng ? 
                                categorieItem.name 
                            :    
                                translate(i18n.language, categorieItem.language, categorieItem.name))
            }
        }
    }, [allmenu, categorie_id]);
                            


    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
          setWindowWidth(window.innerWidth);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, []);



    let contentStyles;

    if (windowWidth >= 1024) {
      contentStyles = styles.contentRecommendedDesktop;
    } else if (windowWidth >= 768) {
      contentStyles = styles.contentRecommendedTablet;
    } else {
      contentStyles = styles.contentRecommendedMobile;
    }

    
    return (
        <LayoutContent>
            <div style={styles.content}>
                <Head title={titleCategorie} />
                <Margin top={15} />

                {categorie_id == 685 ?
                   <div  style={{padding: '0 20px', width: '100%', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                    
                                <img src={require('./assets/cevichebabber.jpg')} style={{
                                    width: '100%',
                                    height: 340, objectFit: 'cover', pointerEvents: 'none',
                                    position: 'relative', zIndex: 1000,
                            borderRadius: 10,
                                    marginBottom: 20
                                  
                                }} />


                             <div
                            style={{
                                width: '100%',
                            
                                
                                justifyContent: 'center',
                                alignItems: 'center',
                                
                                display: 'flex',
                              
                                zIndex: 1,
                                
                            }}>
                                                
                            <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/ceviche.png')} style={{
                                                            width: '100%',
                                height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: 40,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                    </div>


                    : categorie_id == 686 ? 
                    <div  style={{padding: '0 20px', boxSizing: 'border-box', width: '100%',display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                    
                                <img src={require('./assets/IMG_3309-2.jpg')} style={{
                                    width: '100%',
                                    height: 340, objectFit: 'cover', pointerEvents: 'none',
                                    position: 'relative', zIndex: 1000,
                            borderRadius: 10,
                                    marginBottom: 90
                                  
                                }} />


                             <div
                            style={{
                                width: '100%',
                            
                                
                                justifyContent: 'center',
                                alignItems: 'center',
                                
                                display: 'flex',
                                marginTop: -100,
                                zIndex: 1,
                                
                            }}>
                                                
                            <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/chaufas.png')} style={{
                                                            width: '100%',
                                height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: 40,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                    </div>
                    : categorie_id == 688 ? 
                     <div  style={{padding: '0 20px', boxSizing: 'border-box', width: '100%',display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                    
                                <img src={require('./assets/DSC02613.jpg')} style={{
                                    width: '100%',
                                    height: 340, objectFit: 'cover', pointerEvents: 'none',
                                    position: 'relative', zIndex: 1000,
                            borderRadius: 10,
                                    marginBottom: 90
                                  
                                }} />


                             <div
                            style={{
                                width: '100%',
                            
                                
                                justifyContent: 'center',
                                alignItems: 'center',
                                
                                display: 'flex',
                                marginTop: -100,
                                zIndex: 1,
                                
                            }}>
                                                
                            <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/TACOS.png')} style={{
                                                            width: '100%',
                                height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: 40,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                     </div>
                     : categorie_id == 689 ? 
                      <div  style={{padding: '0 20px', boxSizing: 'border-box', width: '100%',display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                             <div
                            style={{
                                width: '100%',
                            
                                
                                justifyContent: 'center',
                                alignItems: 'center',
                                
                                display: 'flex',
                                marginTop: 10,
                                zIndex: 1,
                                
                            }}>
                                                
                            <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/bebidas-frias.png')} style={{
                                                            width: '100%',
                                height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: 40,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                    </div>
                      :
                    categorie_id == 690 ? 
                   <div  style={{padding: '0 20px', boxSizing: 'border-box', width: '100%',display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                             <div
                            style={{
                                width: '100%',
                            
                                
                                justifyContent: 'center',
                                alignItems: 'center',
                                
                                display: 'flex',
                                marginTop: 10,
                                zIndex: 1,
                                
                            }}>
                                                
                            <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/bebidas-calientes.png')} style={{
                                                            width: '100%',
                                height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: 40,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                    </div>
                     : categorie_id == 691 ? 
                    <div  style={{padding: '0 20px', boxSizing: 'border-box', width: '100%',display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                             <div
                            style={{
                                width: '100%',
                            
                                
                                justifyContent: 'center',
                                alignItems: 'center',
                                
                                display: 'flex',
                                marginTop: 10,
                                zIndex: 1,
                                
                            }}>
                                                
                            <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/jugos-naturales.png')} style={{
                                                            width: '100%',
                                height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: 20,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                    </div>
                     :
                    categorie_id == 711 ? 
                     <div  style={{padding: '0 20px', width: '100%', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                    
                                <img src={require('./assets/saladas.jpg')} style={{
                                    width: '100%',
                                    height: 340, objectFit: 'cover', pointerEvents: 'none',
                                    position: 'relative', zIndex: 1000,
                            borderRadius: 10,
                                    marginBottom: 20
                                  
                                }} />


                             <div
                            style={{
                                width: '100%',
                            
                                
                                justifyContent: 'center',
                                alignItems: 'center',
                                
                                display: 'flex',
                              
                                zIndex: 1,
                                
                            }}>
                                                
                            <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/ENSALADAS.png')} style={{
                                                            width: '100%',
                                height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: 40,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                    </div>
                    :
                    <div style={{ ...contentStyles, ...{ paddingInline: 20, position: 'relative' } }}>
                        {
                            menu.map((item) => (
                                <Item
                                    key={item.id.toString()}
                                    menu={item}
                                     allDish={menu}
                                    setShowQr={() => { }}
                                    setUriShare={() => { }}
                                    titleCategorie={titleCategorie}
                                />
                            ))
                        }
                    

                    </div>} 
            </div>
            <Margin top={15} />
        </LayoutContent>
    );
}

export default Index;